"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppAdminUpdateHaulerTransport = exports.HaulerTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const address_transport_1 = require("../common/address-transport");
const currency_1 = require("../stripe-handler/currency");
const dumpster_size_transport_1 = require("./dumpster-size-transport");
const hauler_preferences_transport_1 = require("./hauler-preferences-transport");
const hauler_terms_of_service_transport_1 = require("./hauler-terms-of-service-transport");
const licenseTransport_1 = require("./licenseTransport");
const yard_transport_1 = require("./yard-transport");
exports.HaulerTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    active: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    stateLicenseNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    licences: typebox_1.Type.Optional(typebox_1.Type.Array(licenseTransport_1.LicenseTransport)),
    contactEmail: typebox_1.Type.String(),
    name: typebox_1.Type.String(),
    contactPhoneNumber: typebox_1.Type.String(),
    billingAddress: address_transport_1.AddressTransport,
    yardAddress: typebox_1.Type.Optional(address_transport_1.AddressTransport),
    yards: typebox_1.Type.Array(yard_transport_1.YardTransport),
    website: typebox_1.Type.Optional(typebox_1.Type.String()),
    isSourgumPartner: typebox_1.Type.Boolean(),
    preferences: typebox_1.Type.Array(hauler_preferences_transport_1.HaulerPreferenceTransportValidation),
    defaultRentPeriod: typebox_1.Type.Optional(common_1.Duration),
    maxRentalPeriod: typebox_1.Type.Optional(common_1.Duration),
    rentExtensionFee: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    dumpsterSizes: typebox_1.Type.Array(dumpster_size_transport_1.DumpsterSizeTransport),
    materials: typebox_1.Type.Array(typebox_1.Type.String()),
    stripeAccountID: typebox_1.Type.Optional(typebox_1.Type.String()),
    statementDescriptorSuffix: typebox_1.Type.Optional(typebox_1.Type.String()),
    applicationFeePercent: typebox_1.Type.Optional(typebox_1.Type.Number({ description: 'stored as int Basis points: 500 = 5%' })),
    applicationFeeFlat: typebox_1.Type.Optional(typebox_1.Type.Number({ description: 'stored as int in cents: 500 = $5.00' })),
    billingEnabled: typebox_1.Type.Boolean(),
    billingEnabledDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    logo: typebox_1.Type.Optional(common_1.S3ItemReference),
    waysteLite: typebox_1.Type.Boolean(),
    checkoutEnabled: typebox_1.Type.Boolean(),
    checkoutEnabledDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    checkoutShortID: typebox_1.Type.Optional(typebox_1.Type.String()),
    checkoutLogo: typebox_1.Type.Optional(common_1.S3ItemReference),
    checkoutLogoURL: typebox_1.Type.Optional(typebox_1.Type.String()),
    checkoutLink: typebox_1.Type.Optional(typebox_1.Type.String()),
    checkoutTermsOfService: typebox_1.Type.Optional(hauler_terms_of_service_transport_1.HaulerToSTransport),
    sourgumVendorNumber: typebox_1.Type.Integer(),
    currency: currency_1.Currency,
    metadata: typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    }),
});
exports.AppAdminUpdateHaulerTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(typebox_1.Type.Partial(exports.HaulerTransport), ['metadata']),
    typebox_1.Type.Partial(typebox_1.Type.Object({
        stripeSubscriptionID: typebox_1.Type.Optional(typebox_1.Type.String()),
    })),
]);
//# sourceMappingURL=hauler-transport.js.map